import service from '../../../service/index';
import ui from '@/ui';
import {
  get
} from '@/request/utils';

import {
  CONFIG_DATA
} from "./types";

export default {
  queryConfigById({
    state,
    commit
  }) {
    if (!state.actid) {
      return Promise.reject({
        message: "请求参数缺失"
      })
    }
    return ui.withLoading(service.queryConfigById)(state.actid).then(r => {
      let configData = get(r, "res.bd.data", {});
      commit(CONFIG_DATA, configData);
    });
  },
  sendGoldMember({
    state
  }) {
    if (!state.actid) {
      return Promise.reject({
        message: "请求参数缺失"
      })
    }
    return ui.withLoading(service.sendGoldMember)(state.actid).then(r => {
      return get(r, "res.bd.data", {});
    });
  }
}



// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/receiveFree/store/actions.js